import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Creators as LateExamActions } from '@/domain/useCases/procedures/lateExamen/getLateCourses';
import { Creators as detailActions } from '@/domain/useCases/procedures/getStudentProcedureStatus';
import { Creators as registerActions } from '@/domain/useCases/procedures/lateExamen/registerLateCoursesUseCase';
import { Creators as procedureActions } from '@/domain/useCases/procedures/getProcedureInformation';
import LateExamenRegisterView from './LateExamenRegisterView';
import routes from '@/presentation/components/Routes/routingMap';
import constants from '@/presentation/modules/procedures/constants';
import useExternalSettings from '@/presentation/hooks/useExternalSettings';

const LateExamRegisterViewController = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [selectCourse, setSelectCourse] = useState(null);
  const [listExams, setListExams] = useState<any>([]);
  const [selectTest, setSelectTest] = useState(null);
  const [showExamNoCost, setshowExamNoCost] = useState(false);
  const [isQuit, setIsQuit] = useState(false);

  const { data: getLateCoursesInfo, isLoading: isLoadingCoursesinfo } =
    useSelector((state: any) => state.getLateCourses);

  const { data: profileInfo } = useSelector((state: any) => state.profile);
  // const { data: dataConfig } = useSelector(
  //   (state: any) => state.externalSettings
  // );

  const { currentPeriod } = useExternalSettings();

  const { procedure: procedureInfo, isLoading: isLoadingProcedure } =
    useSelector((state: any) => state.procedureInformation);
  const { isLoading: isProcessingRegister, data: requestId } = useSelector(
    (state: any) => state.registerLateCourses
  );

  useEffect(() => {
    if (!procedureInfo) {
      history.push('/tramites');
    }
  }, [procedureInfo]);

  const handlerChangeCourse = (e: any) => {
    setSelectTest(null);
    const filterExam = getLateCoursesInfo.filter(
      (course: any) => course.id === e
    );
    setListExams(
      filterExam[0].exams.map((course: any) => ({
        value: course.id,
        name: course.name,
        requiredPayment: course.requiredPayment
      }))
    );
    setSelectCourse(e);
  };

  const handlerChangeTest = (e: any) => {
    setSelectTest(e);
  };

  const handlerBackButton = () => {
    if (selectTest) setIsQuit(true);
    else history.goBack();
  };

  const handlerRegisterRequest = () => {
    const courseSelectedToSend = getLateCoursesInfo.filter(
      (course: any) => course.id === selectCourse
    );
    const testSelectedToSend = listExams.filter(
      (x: any) => x.value === selectTest
    );
    const data = {
      procedureId: 1034,
      courseCatalog: courseSelectedToSend[0]?.courseCatalog,
      courseId: selectCourse,
      period: `${currentPeriod}`,
      assessmentType: selectTest,
      assessmentTypeDesc: testSelectedToSend[0]?.name,
      courseDescription: courseSelectedToSend[0]?.name,
      requirePayment: testSelectedToSend[0]?.requiredPayment,
      numberClass: courseSelectedToSend[0]?.numberClass,
      turn: courseSelectedToSend[0]?.turn,
      startDate: courseSelectedToSend[0]?.maxDate
    };
    dispatch(registerActions.registerLateCourses(data));
  };
  const handleCancelquit = () => {
    setIsQuit(false);
  };
  const handleQuit = () => {
    history.push(routes.student.procedures.categories.requests.lateExamen.info);
  };

  useEffect(() => {
    if (!procedureInfo) {
      dispatch(
        procedureActions.getProcedureInformation(
          constants.categories.requests.procedures.examStragglers
        )
      );
    }
  }, []);

  useEffect(() => {
    if (currentPeriod && profileInfo) {
      dispatch(
        LateExamActions.getLateCourses(
          profileInfo.academic.career,
          `${currentPeriod}`
        )
      );
    }
  }, [currentPeriod, profileInfo]);

  useEffect(() => {
    if (requestId > 0) {
      dispatch(detailActions.getStudentProcedureStatus(1034, requestId));
      history.push('/tramites/autogestionables/solicitud/rezagado/progreso');
    }
  }, [requestId]);

  useEffect(() => {
    if (listExams) {
      const testSelectedToSend = listExams.filter(
        (x: any) => x.value === selectTest
      );

      if (testSelectedToSend[0]) {
        setshowExamNoCost(!testSelectedToSend[0]?.requiredPayment);
      }
    }
  }, [selectTest]);

  return (
    <LateExamenRegisterView
      isProcessingRegister={isProcessingRegister}
      handlerBackButton={handlerBackButton}
      handlerChangeCourse={handlerChangeCourse}
      handlerChangeTest={handlerChangeTest}
      handleCancelquit={handleCancelquit}
      handleQuit={handleQuit}
      selectCourse={selectCourse}
      selectTest={selectTest}
      onSubmit={handlerRegisterRequest}
      stepsProcedure={procedureInfo}
      listCourses={getLateCoursesInfo}
      listExams={listExams}
      isLoadingCoursesinfo={isLoadingCoursesinfo || isLoadingProcedure}
      showExamNoCost={showExamNoCost}
      isQuit={isQuit}
    />
  );
};

export default LateExamRegisterViewController;
